<template>
    <section id="second_page_cont" class="page_cont">
        <div class="slide_handler_cont">
                <div v-if="show_slide===true">
                    <b-button class="slide_mode_btn" @click="show_slide=false;sub_track_page('Servizi_info')" variant="danger">INFO</b-button>
                </div>
                <div v-if="show_slide===false">
                    <b-button  class="slide_mode_btn" @click="show_slide=true;sub_track_page('Servizi_slides')" variant="danger">SLIDES</b-button>
                </div>
            </div>
        <div id="second_page_text">
            <div class="info_cont" v-if="show_slide===false">
                <div id="text_service1_cont" class="text_el">
                    <h1 id="service1_title" class="title_">Servizi offerti in loco</h1>
                    <div id="service1" class="body_">
                        <img class="gif" id="minnie_gif1" alt="" src="minnie_gif.gif"/>
                    <ul>
                        <li>Tavoli buffet</li>
                        <li>Tavolo torta</li>
                        <li>Carretto per bevande</li>
                        <li>Sedie</li>
                        <li>Frigorifero</li>
                        <li>Fornello</li>
                        <li>Cassa per musica</li>
                        <li>TV monitor</li>
                        <li>Seggiolino</li>
                        <li>Fasciatoio</li>
                        <li>Phon</li>
                        <li>Area picnic per bambini</li>
                        <li>Biliardino</li>
                        <li>Palla salta salta</li>
                        <li>Aria condizionata</li>
                        <li>Accessibile per disabili</li>
                    </ul>
                    </div>
                </div>

                <div id="text_service1_cont" class="text_el">
                    <h1 id="service1_title" class="title_">I nostri servizi</h1>
                    <div  class="body_">
                        <img class="gif" id="topolino_gif1" alt="" src="topolino_gif1.gif" />

                    <ul >
                        
                        <li>Gonfiabili a scelta</li>
                        <li>Mascotte</li>
                        <li>Macchina del fumo</li>
                        <li>Inviti personalizzati</li>
                        <li>Gadget kit fine festa</li>
                        <li>Allestimento</li>
                        <li>Animazione</li>

                    </ul>
                    </div>
                </div>


                <div id="text_service1_cont" class="text_el">
                    <h1 id="service1_title" class="title_">Servizio fotografico</h1>
                    <div  class="body_">
                        <img class="gif" id="topolino_foto" alt="" src="topolino_foto.jpg" />
                    <div>Ogni scatto sarà raccolto in un CD foto con, in aggiunta,</div> 
                    <div>una foto cartolina momento torta al costo di 10 euro.</div>
                    </div>
                </div>

                <div id="text_service1_cont" class="text_el">
                    <h1 id="service1_title" class="title_">I nostri metodi di pagamento</h1>
                    <div  class="body_">
                        Contanti
                    </div>
                </div>
            </div>
           
            <div class="slides_cont" v-if="show_slide===true">
                <div id="text_gonfiabili_cont" class="text_el">
                    <h1 id="gonfiabili_title" class="title_">I gonfiabili</h1>
                    <div class="text_">
                        <p>Ecco <em>solo alcuni</em> dei nostri gonfiabili!</p>                        
                    </div>
                    {{/*START CAROUSEL */ }}
                    <div id="carousel_cont2.1">
                        <b-carousel
                        id="carousel-2.1"
                        v-model="slide_gonfiabili"
                        :interval=this.interval_gonfiabili
                        controls
                        indicators
                        fade
                        background="transparent"
                        img-width="1024"
                        img-height="480"
                        style="text-shadow: 1px 1px 2px #333;"
                        @sliding-start="onSlideStart(sliding_gonfiabili)"
                        @sliding-end="onSlideEnd(sliding_gonfiabili)"
                        >
                        <!-- Text slides with image -->
                        <span  v-for="(gonfiabile,i) in this.gonfiabili" :key="i.toString()+gonfiabile.caption">
                            <b-carousel-slide
                            :caption="gonfiabile.caption"
                            text=""
                            :img-src="gonfiabile.image"
                            >
                            <!--
                            <div class="carousel-text-cont">
                                <div v-for="(line,i) in gonfiabile.text.split('+')" :key="line+i.toString()">
                                    <p>{{line}}</p>
                                </div>
                            </div>
                             -->
                            <div class="card_social_cont">
                                <div class="for_social" v-for="(social_key,j) in Object.keys(gonfiabile).filter(f=>f.includes('social_'))" :key="i.toString()+social_key+j.toString()">
                                    <div :class="social_key!=='' ?'for_social_sub' :'for_social_pub_empty'" v-if="gonfiabile[social_key]!==''"> <a :href="gonfiabile[social_key]" target="_blank"><font-awesome-icon :icon="`fa-brands fa-${social_key.replace('social_','')}`"/> </a> </div> 
                                </div>
                            </div>

                            </b-carousel-slide>
                        </span>
                        
                    
                    </b-carousel>

                    </div>
                    {{/*END CAROUSEL */ }}
                </div>

                <div id="text_mascotte_cont" class="text_el">
                    <h1 id="mascotte_title" class="title_">Le mascotte</h1>
                    <div class="text_">
                        <p><em>Oltre 50 mascotte</em> disponibili!</p> 
                        <p><em>Ne presentiamo solo alcune.</em></p>
                        <p><button class="link_btn" v-on:click="go_to_page('Contatti')">Contattaci</button> per saperne di più!</p>
                        
                    </div>
                    {{/*START CAROUSEL */ }}
                    <div id="carousel_cont2.2">
                        <b-carousel
                        id="carousel-2.2"
                        v-model="slide_mascotte"
                        :interval=this.interval_mascotte
                        controls
                        indicators
                        fade
                        background="transparent"
                        style="text-shadow: 1px 1px 2px #333;"
                        @sliding-start="onSlideStart(sliding_mascotte)"
                        @sliding-end="onSlideEnd(sliding_mascotte)"
                        >
                        <!-- Text slides with image -->
                        <span  v-for="(mascotte,i) in this.mascotte" :key="i.toString()+mascotte.caption">
                            <b-carousel-slide
                            :caption="mascotte.caption"
                            text=""
                            :img-src="mascotte.image"
                            >
                            <!--
                            <div class="carousel-text-cont">
                                <div v-for="(line,i) in mascotte.text.split('+')" :key="line+i.toString()">
                                    <p>{{line}}</p>
                                </div>
                            </div>
                            -->
                            <div class="card_social_cont">
                                <div class="for_social" v-for="(social_key,j) in Object.keys(mascotte).filter(f=>f.includes('social_'))" :key="i.toString()+social_key+j.toString()">
                                    <div :class="social_key!=='' ?'for_social_sub' :'for_social_pub_empty'" v-if="mascotte[social_key]!==''"> <a :href="mascotte[social_key]" target="_blank"><font-awesome-icon :icon="`fa-brands fa-${social_key.replace('social_','')}`"/> </a> </div> 
                                </div>
                            </div>

                            </b-carousel-slide>
                        </span>
                        
                    
                    </b-carousel>

                    </div>
                    {{/*END CAROUSEL */ }}
                </div>

                <!--
                <div id="text_foto_cont" class="text_el">
                    <h1 id="foto_title" class="title_">Il servizio fotografico</h1>
                    {{/*START CAROUSEL */ }}
                    <div id="carousel_cont2.3">
                        <b-carousel
                        id="carousel-2.3"
                        v-model="slide_fotografia"
                        :interval=this.interval_fotografia
                        controls
                        indicators
                        fade
                        background="transparent"
                        img-width="1024"
                        img-height="480"
                        style="text-shadow: 1px 1px 2px #333;"
                        @sliding-start="onSlideStart(sliding_fotografia)"
                        @sliding-end="onSlideEnd(sliding_fotografia)"
                        >
                       
                        <span  v-for="(foto,i) in this.foto" :key="i.toString()+foto.caption">
                            <b-carousel-slide
                            :caption="foto.caption"
                            text=""
                            :img-src="foto.image"
                            >
                           
                            <div class="carousel-text-cont">
                                <div v-for="(line,i) in foto.text.split('+')" :key="line+i.toString()">
                                    <p>{{line}}</p>
                                </div>
                            </div>
                        
                            <div class="card_social_cont">
                                <div class="for_social" v-for="(social_key,j) in Object.keys(foto).filter(f=>f.includes('social_'))" :key="i.toString()+social_key+j.toString()">
                                    <div :class="social_key!=='' ?'for_social_sub' :'for_social_pub_empty'" v-if="foto[social_key]!==''"> <a :href="foto[social_key]" target="_blank"><font-awesome-icon :icon="`fa-brands fa-${social_key.replace('social_','')}`"/> </a> </div> 
                                </div>
                            </div>
                            </b-carousel-slide>
                        </span>
                        
                    
                    </b-carousel>

                    </div>
                    {{/*END CAROUSEL */ }}
                </div>
                -->

                <div id="text_gadgets_cont" class="text_el">
                    <h1 id="gadgets_title" class="title_">I nostri allestimenti!</h1>
                    <div class="text_">
                        <p>Vi <em>presentiamo solo alcuni allestimenti</em></p>
                        <p>realizzati da </p>
                        <p><em>Group animation & Boing party</em>.</p>
                        <p><a class="link_btn" type="blank_" href="https://instagram.com/groupanimation_boingparty?igshid=OGQ5ZDc2ODk2ZA==">Seguici su instagram</a> per vederli tutti!</p>
                        
                    </div>
                    {{/*START CAROUSEL */ }}
                    <div id="carousel_cont2.4">
                        <b-carousel
                        id="carousel-2.4"
                        v-model="slide_allestimenti"
                        :interval=this.interval_allestimenti
                        controls
                        indicators
                        fade
                        background="transparent"
                        img-width="1024"
                        img-height="480"
                        style="text-shadow: 1px 1px 2px #333;"
                        @sliding-start="onSlideStart(sliding_allestimenti)"
                        @sliding-end="onSlideEnd(sliding_allestimenti)"
                        >
                        <!-- Text slides with image -->
                        <span  v-for="(el,i) in this.allestimenti" :key="i.toString()+el.caption">
                            <b-carousel-slide
                            :caption="el.caption"
                            text=""
                            :img-src="el.image"
                            >
                            <!--
                            <div class="carousel-text-cont">
                                <div v-for="(line,i) in gadget.text.split('+')" :key="line+i.toString()">
                                    <p>{{line}}</p>
                                </div>
                            </div>
                            -->
                            <div class="card_social_cont">
                                <div class="for_social" v-for="(social_key,j) in Object.keys(el).filter(f=>f.includes('social_'))" :key="i.toString()+social_key+j.toString()">
                                    <div :class="social_key!=='' ?'for_social_sub' :'for_social_pub_empty'" v-if="el[social_key]!==''"> <a :href="el[social_key]" target="_blank"><font-awesome-icon :icon="`fa-brands fa-${social_key.replace('social_','')}`"/> </a> </div> 
                                </div>
                            </div>

                            </b-carousel-slide>
                        </span>
                        
                    
                    </b-carousel>

                    </div>
                    {{/*END CAROUSEL */ }}
                </div>


                <div id="text_gadgets_cont" class="text_el">
                    <h1 id="gadgets_title" class="title_">I nostri gadgets!</h1>
                    {{/*START CAROUSEL */ }}
                    <div id="carousel_cont2.4">
                        <b-carousel
                        id="carousel-2.4"
                        v-model="slide_gadgets"
                        :interval=this.interval_gadegts
                        controls
                        indicators
                        fade
                        background="transparent"
                        img-width="1024"
                        img-height="480"
                        style="text-shadow: 1px 1px 2px #333;"
                        @sliding-start="onSlideStart(sliding_gadgets)"
                        @sliding-end="onSlideEnd(sliding_gadgets)"
                        >
                        <!-- Text slides with image -->
                        <span  v-for="(gadget,i) in this.gadgets" :key="i.toString()+gadget.caption">
                            <b-carousel-slide
                            :caption="gadget.caption"
                            text=""
                            :img-src="gadget.image"
                            >
                            <!--
                            <div class="carousel-text-cont">
                                <div v-for="(line,i) in gadget.text.split('+')" :key="line+i.toString()">
                                    <p>{{line}}</p>
                                </div>
                            </div>
                            -->
                            <div class="card_social_cont">
                                <div class="for_social" v-for="(social_key,j) in Object.keys(gadget).filter(f=>f.includes('social_'))" :key="i.toString()+social_key+j.toString()">
                                    <div :class="social_key!=='' ?'for_social_sub' :'for_social_pub_empty'" v-if="gadget[social_key]!==''"> <a :href="gadget[social_key]" target="_blank"><font-awesome-icon :icon="`fa-brands fa-${social_key.replace('social_','')}`"/> </a> </div> 
                                </div>
                            </div>

                            </b-carousel-slide>
                        </span>
                        
                    
                    </b-carousel>

                    </div>
                    {{/*END CAROUSEL */ }}
                </div>

            </div>
           
            
        </div>
    </section>
</template>

<script>

export default{
    name:"SecondPage",
    props:{},
    data(){
        return{
            interval_gonfiabili:10000,
            slide_gonfiabili:0,
            sliding_gonfiabili:null,

            interval_mascotte:10000,
            slide_mascotte:0,
            sliding_mascotte:null,

            interval_fotografia:10000,
            slide_fotografia:0,
            sliding_fotografia:null,

            interval_gadegts:10000,
            slide_gadgets:0,
            sliding_gadgets:null,

            
            interval_allestimenti:10000,
            slide_allestimenti:0,
            sliding_allestimenti:null,
            
            gonfiabili:Array,
            mascotte:Array,
            foto:Array,
            gadgets:Array,
            allestimenti:Array,

            show_slide:false
        }
    },
    mounted(){
    this.gonfiabili= this.$parent.firebase_data["slides"]["gonfiabili"]
    this.mascotte= this.$parent.firebase_data["slides"]["mascotte"]
    this.foto= this.$parent.firebase_data["slides"]["foto"]
    this.gadgets= this.$parent.firebase_data["slides"]["gadgets"]
    this.allestimenti=this.$parent.firebase_data["slides"]["allestimenti"]

    this.$parent.track_page("Servizi_info")




    },
    methods:{
        onSlideStart(sliding) {
        sliding = true

      },
      onSlideEnd(sliding) {
        sliding = false
      },
      go_to_page(page) {
            //alert("a")
            //this doesn't work because the listener must be set as a prop of a component, not in the component itself (i.e., App.vue)
            //opt for scroll approach instead
            //this.$emit('change-page-from-child',page_n)
            this.$parent.target_page = page;
            window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
        },
        sub_track_page(page_name){
            this.$parent.track_page(page_name)
        }
    },
    watch:{

    }
}
</script>

<style scoped>

  #minnie_gif1{
        position: absolute;
        z-index:1;
        left:0px;
        top:3%;
        scale:0.6;
        width: 25%;
    }

    #topolino_gif1{
        position: relative;
        z-index:1;
        scale:1;
        width: 10em!important;
        top:-10px;
        left: 0px;

        
    }
    #topolino_foto{
        position: relative;
        z-index:1;
        scale:1;
        width: 5em!important;
        top:-10px;
        left: 0px;

    }

    .card_social_cont{
    margin-top:-2%
    }

    .carousel-caption h3{
  margin-top: -1%!important;
  text-shadow: var(--body_bg) 3px 1px 10px;
  font-size: 18px!important;
  background-color: white!important;
}
@media only screen and (max-width:500px){
    .card_social_cont{
    margin-top:3%!important
}
}
@media only screen and (max-width:1400px){
#minnie_gif1{
        position: absolute;
        z-index:1;
        left:0px;
        top:3%;
        scale:0.5;
        width: 10em!important;

    }

    #topolino_gif1{
        position: relative;
        z-index:1;
        scale:1;
        width: 10em!important;
        top:-10px;
        left: 0px;


    }

    #topolino_foto{
        position: relative;
        z-index:1;
        scale:1;
        width: 5em!important;
        top:-10px;
        left: 0px;

        
    }
}

@media only screen and (max-width:1000px){
    #minnie_gif1{
        position: absolute;
        z-index:1;
        left:0px;
        top:3%;
        scale:0.6;
        width: 10em!important;

    }

    #topolino_gif1{
        position: relative;
        z-index:1;
        scale:1;
        width: 10em!important;
        top:-10px;
        left: 0px;

        

    }
    #topolino_foto{
        position: relative;
        z-index:1;
        scale:1;
        width: 5em!important;
        top:-10px;
        left: 0px;

    }

}

@media(pointer:coarse){

    @media(orientation:landscape){
        #minnie_gif1{
        position: absolute;
        z-index:1;
        left:0px;
        scale:0.6;
        width: 10em!important;
        top:3%;

    }

    #topolino_gif1{
        position: relative;
        z-index:1;
        scale:1;
        width: 10em!important;
        
    }

    #topolino_foto{
        position: relative;
        z-index:1;
        scale:1;
        width: 5em!important;
        top:-10px;
        left: 0px;

    }


    }

    @media(orientation:portrait){
        #minnie_gif1{
        position: absolute;
        z-index:1;
        left:0px;
        top:3%;
        scale:0.6;
        width: 10em!important;

    }

    #topolino_gif1{
        position: relative;
        z-index:1;
        top: 0vh;
        scale:1;
        width: 10em!important;

    }

    #topolino_foto{
        position: relative;
        scale: 1;
        width: 5em!important;
        left: 0px;
    }

    .text_{
    width: 50%!important;
    margin-left: auto;
    margin-right: auto;
}
.carousel-caption h3{
        background-color: white!important;
    }


    }

    

}


svg:not(:root).svg-inline--fa, svg:not(:host).svg-inline--fa{
    position:relative;
    top:3px
}

 ul{
    position: relative;
    z-index: 2;
    list-style: none;
}

.slide_handler_cont{
    text-align: center;
    width: 10%;
    padding: 1%;
    position:fixed;
    margin-left: -25px;
    margin-top:25px

}

.slide_handler_cont button{
    text-align: center;
    width: 100px;
    height: 100px;
    color: white;
    font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
    font-size:18px;
    margin-bottom: 5px;
    border-radius: 50%!important;
    
}



.text_el{
    background-color: white;
    border-radius: 1em 1em 0em 0em;
}

.text_{
    width: 25%;
    margin-left: auto;
    margin-right: auto;
    text-align: center;
}






</style>
